import React from "react";
import OrderConfirmModal from "../Components/modals/orderConfirmmodal";
function OrderConfirm() {
  return (
    <div>
      <h1>order confirm</h1>
      <OrderConfirmModal />
    </div>
  );
}

export default OrderConfirm;
